export default import.meta.ROLLDOWN_FILE_URL__Espx2EkBpJC0VwEAZifMA